import { pathOr } from 'ramda';
import {
  BC_CONTRACT_EMAIL_BODY_CONTENT,
  BC_CONTRACT_EMAIL_SUBJECT,
  BC_CONTRACT_PRE_FIELDS_CHECK_BOX_FIELDS,
  BC_CONTRACT_PRE_TEXT_FIELDS,
} from './00011_breakoutApplicantTemplate';

////////////////////////////
const contractInputs = {
  BC_CONTRACT: {
    FUNDALOAN: {
      CONTRACT_PRE_TEXT_FIELDS: BC_CONTRACT_PRE_TEXT_FIELDS,
      CONTRACT_EMAIL_BODY_CONTENT: BC_CONTRACT_EMAIL_BODY_CONTENT,
      CONTRACT_EMAIL_SUBJECT: BC_CONTRACT_EMAIL_SUBJECT,
      CONTRACT_PRE_FIELDS_CHECK_BOX_FIELDS:
        BC_CONTRACT_PRE_FIELDS_CHECK_BOX_FIELDS,
    },
  },
  APP_CONTRACT: {
    FUNDALOAN: {
      CONTRACT_PRE_TEXT_FIELDS: BC_CONTRACT_PRE_TEXT_FIELDS,
      CONTRACT_EMAIL_BODY_CONTENT: BC_CONTRACT_EMAIL_BODY_CONTENT,
      CONTRACT_EMAIL_SUBJECT: BC_CONTRACT_EMAIL_SUBJECT,
      CONTRACT_PRE_FIELDS_CHECK_BOX_FIELDS:
        BC_CONTRACT_PRE_FIELDS_CHECK_BOX_FIELDS,
    },
  }
};
export const getContractInputFields = (input: string, loanType: string) => {
  return pathOr('', [input, loanType], contractInputs);
};
